import React from "react";

const Home: React.FC = () => {
  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "auto",
        fontSize: "1.1rem",
        lineHeight: "1.6",
      }}
    >
      <h1>¡Bienvenidos a nuestro restaurante!</h1>
      <p>
        En <strong>Delicias Andinas</strong> te invitamos a disfrutar de una
        experiencia gastronómica única, donde la tradición peruana se mezcla con
        sabores frescos y auténticos. Cada plato está elaborado con ingredientes
        de la mejor calidad, cuidando cada detalle para que vivas momentos
        inolvidables.
      </p>
      <p>
        Descubre nuestro variado menú con ceviches, causas, lomo saltado y mucho
        más. Nuestro equipo está listo para atenderte con calidez y dedicación.
      </p>
      <p>
        Para explorar todas nuestras opciones, por favor haz clic en la sección{" "}
        <strong>PRODUCTOS</strong>.
      </p>
      <p>
        ¡Esperamos darte la bienvenida muy pronto y que disfrutes cada bocado de
        nuestra cocina!
      </p>
    </div>
  );
};

export default Home;
